<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<div class="jurisdiction-tips" v-show="tips">未取得成都经纪人资格证的员工不能申请正式名片，若已取得请先联系行政部陈兰州上传ID号后再申请</div>
		<div class="card-examples" v-show="imgShow">
			<div class="title">示例展示</div>
			<div class="card-examples-arr">
				<div class="block" v-for="(item ,index) in cardArr[cardIndex]" :key="'card'+index">
					<img preview="card" :src="item" />
				</div>
			</div>
		</div>
		<Button class="submit-process" v-on:click='submit' size="large" type="primary"> 提交 </Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import wimg from "w-previewimg";
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import {
		initWxConfig
	} from "../api/jssdk.js";
	import stringUtils from "../assets/js/stringUtil.js";
	import wx from 'weixin-js-sdk'

	import {
		getRelation,
		getUserInfo,
		getAgentInfo
	} from '@/api/employee'

import {
		formatDate
	} from '@/utils/date'

	import {
		getDepartmentRelationByName,
		getDepartmentRelationById,
		getDepartmentInfo
	} from '@/api/department'

	import {
		getTemplateInfo,
		submitProcess,
		sendMessage,
		getFlowTemplate
	} from '@/api/approval'
	import {
		GetFirstComplaintsHotline
	} from '@/api/businesscard.js'

	var templateData = {
		TemplateContent: {
			Controls: []
		}
	};
	var logInfo = null;
	var userInfo = null; // 使用者信息
	var agentInfo = null; // 经纪人相关信息

	var isSubmit = false;

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				"templateData": templateData,
				cardIndex: 12,
				cardArr: [
					[
						"https://cdimage.centaline.com.cn/read-file/png/2023/202302/20230216/a356c3f4-1316-4b51-87b9-888828ca7d3b.png"
					], //0	1-房友圈.-联动拓展部.png
					[
						"https://cdimage.centaline.com.cn/read-file/png/2020/202011/20201103/162653-1259a511-c880-42b4-97dd-97a588fda80e.png"
					], //1	2-房友圈联动项目部、企业顾问中心、赋能中心.png
					[
						"https://cdimage.centaline.com.cn/read-file/jpg/2020/202011/20201103/162653-9136520e-3136-4b49-a829-ee4a745a7eea.jpg"
					], //2	3-汇瀚.jpg
					[
						"https://cdimage.centaline.com.cn/read-file/png/2020/202011/20201103/162653-e09c6994-49b5-480a-af3e-f841f1329b3f.png"
					], //3	4-非营业&二级市场.png
					[
						"https://cdimage.centaline.com.cn/read-file/png/2020/202011/20201103/162653-d1b2c104-f9c5-4584-b4c2-a4cf6e85f770.png"
					], //4	5-a-无荣誉工商铺（销售经理职级含以上）.png
					[
						"https://cdimage.centaline.com.cn/read-file/png/2020/202011/20201103/162654-57074a34-86a6-4fb0-9ef3-ae13a62b711b.png"
					], //5	5-a-有荣誉工商铺（销售经理职级含以上）.png
					[
						"https://cdimage.centaline.com.cn/read-file/png/2020/202011/20201103/162654-ba931f6f-2d1d-4446-8aac-5845e5b98355.png"
					], //6	5-b-无荣誉工商铺（销售经理职级及以下）.png
					[
						"https://cdimage.centaline.com.cn/read-file/png/2020/202011/20201103/162654-94f51585-98f0-4e28-a1a0-7ecf260926ad.png"
					], //7	5-b-有荣誉工商铺（销售经理职级以下）.png
					[
						"https://cdimage.centaline.com.cn/read-file/png/2020/202011/20201103/162654-2c53b021-8c61-4a39-99a9-3c4df6f1b506.png"
					], //8	6-a-无荣誉住宅部（分行店董职级含以上）.png
					[
						"https://cdimage.centaline.com.cn/read-file/png/2020/202011/20201103/162654-e7b6422d-8eef-4f03-afe8-ef347fdb50e6.png"
					], //9	6-a-有荣誉住宅部（分行店董职级含以上）.png
					[
						"https://cdimage.centaline.com.cn/read-file/png/2020/202011/20201103/162654-57a0cad6-3e52-488c-934a-a2e2ff533dcb.png"
					], //10	6-b-无荣誉住宅部（分行店董职级及以下）.png
					[
						"https://cdimage.centaline.com.cn/read-file/png/2020/202011/20201103/162654-8ec5ba56-e63e-43b9-864d-3e94c5cb58b5.png"
					], //11	6-b-有荣誉住宅部（分行店董职级以下）.png
					[
						"https://cdimage.centaline.com.cn/read-file/jpg/2020/202011/20201103/162654-e8a05591-a320-49b5-afc7-0b35a6f4e4ae.jpg",
						"https://cdimage.centaline.com.cn/read-file/png/2020/202011/20201103/162654-29c33af1-369f-43d1-8071-d83f9632278e.png"
					] //12	7-空白名片正面.jpg 7-空白名片背面.png
				],
				imgShow: false,
				branchAddress: '',
				tips: false,
				honor: '',
				listLoading: false,
				spNo: null,
			}
		},
		mounted() { //页面挂载
			initWxConfig(this);
			this.getTemplate();
			stringUtils.setAddIsShow(false);
			this.spNo = this.$route.query.spNo;
		},
		watch: {

		},
		created() {},
		methods: { //方法

			clickChoose(dataVal, name) {
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department", "user"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var selectedDepartmentList = res.result.departmentList; // 已选的部门列表

						for (var i = 0; i < selectedDepartmentList.length; i++) {
							var department = selectedDepartmentList[i];
							dataVal.Values.push([department.id, department.name]); // 已选的单个部门ID
							dataVal.Value = department.name; // 已选的单个部门名称
						}

					}
				})
			},
			getTemplate: async function() {
				let that = this;

				that.$http({
					url: that.$httpUrl.getTemplate + "?templateId=" + stringUtils.GetQueryString("templateId"),
					method: "get",
				}).then(async res => {
					if (res.data == null || res.data.ErrCode != 0) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '模板获取错误'
						});
						return;
					}
					var controls = res.data.Body;
					that.templateData = res.data.Body;
					logInfo = JSON.parse(localStorage.getItem('logInfo'));
					if (logInfo == null) {
						logInfo = JSON.parse(stringUtils.getCookies("logInfo"));
					}
					for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
						if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "人员") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "工号") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "使用者工号") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.EmpNo;
							that.getTextVal(logInfo.EmpNo, '使用者工号');
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "入职时间") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.InCompanyDate;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "联系电话") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.Mobile;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "职位") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.PositionName;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "分行行政") {
							that.templateData.TemplateContent.Controls[i].IsShow = false;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "流程条件") {
							that.templateData.TemplateContent.Controls[i].Value = -1;
							that.templateData.TemplateContent.Controls[i].IsShow = false;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "申请时间") {
							let date = new Date();
							that.templateData.TemplateContent.Controls[i].Value = formatDate(date,"yyyy-MM-dd");
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "端口费用承担部门") {
							that.templateData.TemplateContent.Controls[i].Value = logInfo.DeptName;
						}

					}
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.hideInfo();
				}, err => {
					console.log(err)
				});
			},
			reset() {
				this.imgShow = false;
				this.branchAddress = '';
				this.tips = false;
				this.honor = '';
			},
			getTextVal: async function(value1, val) {
				if(val != "使用者工号"){
					return;
				}
				let that = this;
				that.reset();
				var directSuperiors = {};
				if (value1 == null || value1 == '') {
					return;
				}
				if (val == "使用者工号") {
					let isOk = value1.match(/(sc|SC|HB|hb)[0-9]{8}/);
					if (isOk == null) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '请输入正确的工号'
						});
						return;
					}
					await getUserInfo(value1).then(response => {
						userInfo = response.Body.EmployeeInfo;
						that.queryAddress();
					});
					if (userInfo == null || userInfo.length == 0) {
						that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
							background: true,
							content: '请输入正确的工号'
						});
						return;
					}
					await getRelation(value1).then(response => {
						for (let j = 0; j < response.Body[0].Nodes.length; j++) {
							if (response.Body[0].Nodes[j].Items != null) {
								directSuperiors = response.Body[0].Nodes[j].Items[0];
								break;
							}
						}
					});

					await getAgentInfo(value1).then(response => {
						agentInfo = response;
					})
					this.listLoading = true;

					this.showInfo();
					that.templateData.TemplateContent.Controls.forEach(async (item) => {
						if (item.Property.Title[0].Text == "流程条件") {
							item.Value = -1;
							if (userInfo.fullName.indexOf("住宅部") > -1) {
								if (userInfo.fullName.indexOf("非营业") > -1) {
									item.Value = "4.2";
								} else {
									item.Value = "4.1";
								}

							} else if (userInfo.fullName.indexOf("非营业") > -1) {
								item.Value = "1";
							} else if (userInfo.fullName.indexOf("工商铺") > -1 || userInfo.fullName.indexOf("商业地产部") > -1) {
								item.Value = "2";
							} else if (userInfo.fullName.indexOf("按揭金融服务中心") > -1) {
								item.Value = "3";
							} else if (userInfo.fullName.indexOf("二级市场") > -1 || userInfo.fullName.indexOf("代理") > -1) {
								item.Value = "5";
							} else if (userInfo.fullName.indexOf("房友圈") > -1 || userInfo.fullName.indexOf("藤云")) {
								item.Value = "6";
							}
						} else if (item.Property.Title[0].Text == "分行行政") {
							item.IsShow = false;
							item.Values = [];
							getDepartmentRelationByName(userInfo.fullName, false).then(async response => {
								if (response.Body != null && response.Body.length > 0) {
									for (let j = 0; j < response.Body.length; j++) {
										let emps = await that.findEmpByPositionName(response.Body[j].Nodes, "行政助理");
										if (emps.length > 0) {
											item.Values=item.Values.concat(emps)
										}
									}
									if (item.Values == null || item.Values.length == 0) {
										item.Values = await that.findEmpByPositionName(response.Body[0].Nodes, "行政主管");
                    console.log("行政主管")
                    console.log(item.Values)
									}
									if (item.Values == null || item.Values.length == 0) {
										item.Values = await that.findEmpByPositionName(response.Body[0].Nodes, "行政主任");
                    console.log("行政主任")
                    console.log(item.Values)
									}
								}
								if (item.Values == null || item.Values.length == 0) {
									item.Values = [];
									item.Values.push(that.$store.state.defaultMember);
								}
								if (item.Values[0][0] == "SC16003267") {
									item.Values = [
										["SC16001667", "练燕"]
									];
								}
								
							});
						}
					});
					that.templateData.TemplateContent.Controls.forEach(async (item) => {
						if (item.Property.Title[0].Text == "分行地址") {
							item.Value = "空";
							item.IsShow = false;
							item.Disable = true;
							let data = userInfo.fullName.split("/");
							for (let j = data.length; j > 0; j--) {
								if (data[j - 1].match(/\S{1,}分行/) != null || data[j - 1].match(/((写字楼)|(渠道))(一|二|三|四)部/) != null) {
									item.IsShow = true;
									that.$http({
										url: that.$httpUrl.QueryAddress + "?deptName=" + data[j - 1],
										method: "get",
									}).then(res => {
										if (res.data.body != null) {
											for (let k = 0; k < res.data.body.length; k++) {
												if (res.data.body[k].deptName.indexOf("后勤") == -1 && res.data.body[k].deptName.indexOf("组") == -1) {
													item.Value = res.data.body[k].address;
													if (item.Value == null||item.Value == '') {
														item.IsShow = false;
													}
												}
											}
										}
									})
								}
							}
						}
					})
					if (userInfo.fullName.indexOf("住宅部") > -1 && userInfo.fullName.indexOf("非营业部") == -1 && (agentInfo.Body == null ||
							agentInfo.Body.agentCardNumber == null || agentInfo.Body.agentCardNumber.length == 0)) {
						// if (userInfo.fullName.indexOf("住宅部") > -1 && (agentInfo.Body == null || agentInfo.Body.agentCardNumber ==
						// 		null || agentInfo.Body.agentCardNumber.length == 0)) {
							
						// 	// await getAgentInfo(directSuperiors.EmpNo).then(response => {
						// 	// 	agentInfo.Body.agentCardNumber = response.Body.agentCardNumber
						// 	// 	if (agentInfo.Body.agentCardNumber == null) {
						// 	// 		that.tips = true;
						// 	// 		this.hideInfo();
						// 	// 		that.templateData.TemplateContent.Controls.forEach(async (item) => {
						// 	// 			if (item.Property.Title[0].Text == "是否空名片") {
						// 	// 				item.Config.Selector.Options.forEach(async (option) => {
						// 	// 					if (option.Value[0].Text == "是") {
						// 	// 						item.Value = option.Key;
						// 	// 						item.Disable = true;
						// 	// 						that.cardIndex = 12;
						// 	// 						this.imgShow = true;
						// 	// 					}
						// 	// 				});
						// 	// 			}
						// 	// 		});
						// 	// 		this.listLoading = false;
						// 	// 		return;
						// 	// 	}
						// 	// })

						// }
						if (agentInfo.Body == null) {
							that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
								background: true,
								content: '没有人员信息'
							});
						}

						
					} else {
						// that.templateData.TemplateContent.Controls.forEach(async (item) => {
						// 	if (item.Property.Title[0].Text == "是否空名片") {
						// 		item.Config.Selector.Options.forEach(async (option) => {
						// 			if (userInfo.fullName.indexOf("非营业部") > -1) {
						// 				item.Disable = true;
						// 			} else {
						// 				item.Disable = false;
						// 			}
						// 			if (option.Value[0].Text == "否") {
						// 				item.Value = option.Key;
						// 			}
						// 		});
						// 	}
						// });
					}
					for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
						if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "个人荣誉") {
							// if (userInfo.fullName.indexOf("联动拓展部") > -1) {
							// 	that.cardIndex = 0;
							// 	let ii = i;
							// 	that.$http({
							// 		url: that.$httpUrl.GetPersonalAllHonour + "?empNo=" + value1,
							// 		method: "get",
							// 	}).then(res => {
							// 		if (res.data.body.indexOf('DSA') > -1) {
							// 			that.imgShow = false
							// 			that.honor = 'DSA'
							// 		} else {
							// 			that.imgShow = true
							// 		}
							// 	});
							// } else
							//   if (userInfo.fullName.indexOf("联动项目部") > -1 ||
							// 	userInfo.fullName.indexOf("企业顾问中心") > -1 ||
							// 	userInfo.fullName.indexOf("赋能中心") > -1) {
              if (userInfo.fullName.indexOf("藤云") > -1) {
								that.cardIndex = 0;
								that.templateData.TemplateContent.Controls[i].Disable = true;
								let ii = i;
								that.$http({
									url: that.$httpUrl.GetPersonalAllHonour + "?empNo=" + value1,
									method: "get",
								}).then(res => {
									if (res.data.body.indexOf('DSA') > -1) {
										that.imgShow = false
										that.honor = 'DSA'
									} else {
										that.imgShow = true
									}
									that.templateData.TemplateContent.Controls[ii].Value = res.data.body;
									if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[
											ii].Value.length == 0) {
										that.templateData.TemplateContent.Controls[ii].IsShow = false;
									}
								});
							}
							else if (userInfo.fullName.indexOf("按揭金融服务中心") > -1) {
								that.templateData.TemplateContent.Controls[i].Disable = true;
								that.cardIndex = 2;
								let ii = i;
								that.$http({
									url: that.$httpUrl.GetPersonalAllHonour + "?empNo=" + value1,
									method: "get",
								}).then(res => {
									that.templateData.TemplateContent.Controls[ii].Value = res.data.body;
									console.log('zzz')
									if (res.data.body.indexOf('DSA') > -1) {
										that.imgShow = false
										that.honor = 'DSA'
									} else {
										that.imgShow = true
									}
									if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[ii].Value.length == 0) {
										that.templateData.TemplateContent.Controls[ii].IsShow = false;
									}
								});
							} else if (userInfo.fullName.indexOf("非营业部") > -1 ||
								userInfo.fullName.indexOf("二级市场") > -1 ||
								userInfo.fullName.indexOf("代理") > -1) {
								that.cardIndex = 3;
								that.templateData.TemplateContent.Controls[i].Disable = true;
								let ii = i;
								that.$http({
									url: that.$httpUrl.GetPersonalAllHonour + "?empNo=" + value1,
									method: "get",
								}).then(res => {
									that.templateData.TemplateContent.Controls[ii].Value = res.data.body;
									if (res.data.body.indexOf('DSA') > -1) {
										that.imgShow = false
										that.honor = 'DSA'
									} else {
										that.imgShow = true

									}
									if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[
											ii].Value.length == 0) {
										that.templateData.TemplateContent.Controls[ii].IsShow = false;
									}
								});
							} else if (userInfo.fullName.indexOf("商业地产部") > -1) {
								that.templateData.TemplateContent.Controls[i].Disable = true;
								let ii = i;
								if (userInfo.JobLevel >= 3) {
									that.$http({
										url: that.$httpUrl.GetPersonalAllHonour + "?empNo=" + value1,
										method: "get",
									}).then(res => {
										if (res.data.body.indexOf('DSA') > -1) {
											that.imgShow = false
											that.honor = 'DSA'
										} else {
											that.imgShow = true
										}
										that.templateData.TemplateContent.Controls[ii].Value = res.data.body;
										if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[
												ii].Value.length == 0) {
											that.templateData.TemplateContent.Controls[ii].IsShow = false;
										}
										if (!res.data.body) {
											that.cardIndex = 4;
										} else {
											that.cardIndex = 5;
										}
									});
								} else {
									that.$http({
										url: that.$httpUrl.GetPersonalAllHonour + "?empNo=" + value1,
										method: "get",
									}).then(res => {
										if (res.data.body.indexOf('DSA') > -1) {
											that.imgShow = false
											that.honor = 'DSA'
										} else {
											that.imgShow = true
										}
										that.templateData.TemplateContent.Controls[ii].Value = res.data.body;
										if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[
												ii].Value.length == 0) {
											that.templateData.TemplateContent.Controls[ii].IsShow = false;
										}
										if (!res.data.body) {
											that.cardIndex = 6;
										} else {
											that.cardIndex = 7;
										}
									});
								}

							} else if (userInfo.fullName.indexOf("住宅部") > -1) {
								that.templateData.TemplateContent.Controls[i].Disable = true;
								let ii = i;
								if (userInfo.JobLevel >= 4) {
									that.$http({
										url: that.$httpUrl.GetPersonalAllHonour + "?empNo=" + value1,
										method: "get",
									}).then(res => {
										if (res.data.body.indexOf('DSA') > -1) {
											that.imgShow = false
											that.honor = 'DSA'
										} else {
											that.imgShow = true
										}
										that.templateData.TemplateContent.Controls[ii].Value = res.data.body;
										if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[
												ii].Value.length == 0) {
											that.templateData.TemplateContent.Controls[ii].IsShow = false;
										}
										if (!res.data.body) {
											that.cardIndex = 8;
										} else {
											that.cardIndex = 9;
										}
									});
								} else {
									that.$http({
										url: that.$httpUrl.GetPersonalAllHonour + "?empNo=" + value1,
										method: "get",
									}).then(res => {
										if (res.data.body.indexOf('DSA') > -1) {
											that.imgShow = false
											that.honor = 'DSA'
										} else {
											that.imgShow = true
										}
										that.templateData.TemplateContent.Controls[ii].Value = res.data.body;
										if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[
												ii].Value.length == 0) {
											that.templateData.TemplateContent.Controls[ii].IsShow = false;
										}
										if (!res.data.body) {
											that.cardIndex = 10;
										} else {
											that.cardIndex = 11;
										}
									});
								}
							} else if (
								userInfo.fullName.indexOf("代理") > -1) {
								that.templateData.TemplateContent.Controls[i].Disable = true;
								let ii = i;
								that.$http({
									url: that.$httpUrl.GetPersonalAllHonour + "?empNo=" + value1,
									method: "get",
								}).then(res => {
									if (res.data.body.indexOf('DSA') > -1) {
										that.imgShow = false
										that.honor = 'DSA'
									} else {
										that.imgShow = true
									}
									that.templateData.TemplateContent.Controls[ii].Value = res.data.body;
									if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[
											ii].Value.length == 0) {
										that.templateData.TemplateContent.Controls[ii].IsShow = false;
									}
								});
							} else {
								that.templateData.TemplateContent.Controls[i].IsShow = false;
							}
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "个人微店网址") {
							if (userInfo.fullName.indexOf("住宅部") > -1 && userInfo.fullName.indexOf("非营业部") == -1) {
								let ii = i;
								that.$http({
									url: that.$httpUrl.GetOtherInfoByTypeName + "?typeName=微店网址",
									method: "get",
								}).then(res => {
									that.templateData.TemplateContent.Controls[ii].Value = res.data.body.value + userInfo.EmpNo;
									that.templateData.TemplateContent.Controls[ii].Disable = true;
									if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[
											ii].Value.length == 0) {
										that.templateData.TemplateContent.Controls[ii].IsShow = false;
									}
								})
							} else {
								that.templateData.TemplateContent.Controls[i].IsShow = false;
							}
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "公司地址") {
							let ii = i;
							that.$http({
								url: that.$httpUrl.GetOtherInfoByTypeName + "?typeName=公司地址",
								method: "get",
							}).then(res => {
								that.templateData.TemplateContent.Controls[ii].Value = res.data.body.value;
								that.templateData.TemplateContent.Controls[ii].Disable = true;
								if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[
										ii].Value.length == 0) {
									that.templateData.TemplateContent.Controls[ii].IsShow = false;
								}
							})
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "公司电话") {
							if (userInfo.fullName.indexOf("按揭金融服务中心") > -1) {
								let ii = i;
								that.$http({
									url: that.$httpUrl.GetOtherInfoByTypeName + "?typeName=公司电话",
									method: "get",
								}).then(res => {
									that.templateData.TemplateContent.Controls[ii].Value = res.data.body.value;
									that.templateData.TemplateContent.Controls[ii].Disable = true;
									that.templateData.TemplateContent.Controls[ii].IsShow = true;
									if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[
											ii].Value.length == 0) {
										that.templateData.TemplateContent.Controls[ii].IsShow = false;
									}
								})
							} else {
								that.templateData.TemplateContent.Controls[i].IsShow = false;
							}

						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "投诉热线") {
							if (userInfo.fullName.indexOf("非营业部") > -1 ||
								userInfo.fullName.indexOf("二级市场") > -1 ||
								userInfo.fullName.indexOf("代理") > -1 ||
								userInfo.fullName.indexOf("住宅部") > -1 ||
								userInfo.fullName.indexOf("商业地产部") > -1) {
								let data = userInfo.fullName.split("/");
								var complaintsHotline = null;
								for (let j = data.length; j > 0; j--) {
									await GetFirstComplaintsHotline(data[j - 1]).then(response => {
										complaintsHotline = response.body;
									});
									if (complaintsHotline != null) {
										that.templateData.TemplateContent.Controls[i].Value = complaintsHotline.phoneNumber;

										break;
									}
									if (that.templateData.TemplateContent.Controls[i].Value == null || that.templateData.TemplateContent.Controls[
											i].Value.length == 0) {
										that.templateData.TemplateContent.Controls[i].IsShow = false;
									}
								}
								that.templateData.TemplateContent.Controls[i].Disable = true;
							} else {
								that.templateData.TemplateContent.Controls[i].IsShow = false;
							}

						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "投诉邮箱") {
							if (userInfo.fullName.indexOf("非营业部") > -1 ||
								userInfo.fullName.indexOf("二级市场") > -1 ||
								userInfo.fullName.indexOf("代理") > -1 ||
								userInfo.fullName.indexOf("住宅部") > -1 ||
								userInfo.fullName.indexOf("商业地产部") > -1) {
								let ii = i;
								that.$http({
									url: that.$httpUrl.GetOtherInfoByTypeName + "?typeName=投诉邮箱",
									method: "get",
								}).then(res => {
									that.templateData.TemplateContent.Controls[ii].Value = res.data.body.value;
									that.templateData.TemplateContent.Controls[ii].Disable = true;
									that.templateData.TemplateContent.Controls[ii].IsShow = true;
									if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[
											ii].Value.length == 0) {
										that.templateData.TemplateContent.Controls[ii].IsShow = false;
									}
								})
							} else {
								that.templateData.TemplateContent.Controls[i].IsShow = false;
							}

						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "官网地址") {
							if (userInfo.fullName.indexOf("非营业部") > -1 ||
								userInfo.fullName.indexOf("二级市场") > -1 ||
								userInfo.fullName.indexOf("代理") > -1 ||
								userInfo.fullName.indexOf("住宅部") > -1 ||
								userInfo.fullName.indexOf("商业地产部") > -1) {
								let ii = i;
								that.$http({
									url: that.$httpUrl.GetOtherInfoByTypeName + "?typeName=官网地址",
									method: "get",
								}).then(res => {
									that.templateData.TemplateContent.Controls[ii].Value = res.data.body.value;
									that.templateData.TemplateContent.Controls[ii].Disable = true;
									that.templateData.TemplateContent.Controls[ii].IsShow = true;
									if (that.templateData.TemplateContent.Controls[ii].Value == null || that.templateData.TemplateContent.Controls[
											ii].Value.length == 0) {
										that.templateData.TemplateContent.Controls[ii].IsShow = false;
									}
								})
							} else {
								that.templateData.TemplateContent.Controls[i].IsShow = false;
							}

						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "姓名") {
							that.templateData.TemplateContent.Controls[i].Value = userInfo.EmpName;
							that.templateData.TemplateContent.Controls[i].Disable = true;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门名称") {
							if (userInfo.fullName.indexOf("非营业部") > -1 ||
								userInfo.fullName.indexOf("二级市场") > -1 ||
								userInfo.fullName.indexOf("代理") > -1 ||
								userInfo.fullName.indexOf("住宅部") > -1 ||
								userInfo.fullName.indexOf("联动项目部") > -1 ||
								userInfo.fullName.indexOf("企业顾问中心") > -1 ||
								userInfo.fullName.indexOf("赋能中心") > -1 ||
								userInfo.fullName.indexOf("商业地产部") > -1) {
								that.templateData.TemplateContent.Controls[i].Value = userInfo.DeptName;
								that.templateData.TemplateContent.Controls[i].Disable = true;
								if (that.templateData.TemplateContent.Controls[i].Value == null || that.templateData.TemplateContent.Controls[
										i].Value.length == 0) {
									that.templateData.TemplateContent.Controls[i].IsShow = false;
								}
							} else {
								that.templateData.TemplateContent.Controls[i].IsShow = false;
							}

						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "职位名称") {
							that.templateData.TemplateContent.Controls[i].Value = userInfo.PositionName;
							that.templateData.TemplateContent.Controls[i].Disable = true;
							if(userInfo.fullName.indexOf("营业部/工商铺商业运营中心/项目部") > -1){
								if(userInfo.PositionName == '项目总监'){
									that.templateData.TemplateContent.Controls[i].Value = '项目部总经理';
								}else if(userInfo.PositionName == '高级项目销售经理'){
									that.templateData.TemplateContent.Controls[i].Value = '高级项目总监';
								}else if(userInfo.PositionName == '项目销售经理'){
									that.templateData.TemplateContent.Controls[i].Value = '项目总监';
								}else if(userInfo.PositionName == '项目销售主管'){
									that.templateData.TemplateContent.Controls[i].Value = '销售经理助理';
								}else if(userInfo.PositionName == '高级置业顾问'){
									that.templateData.TemplateContent.Controls[i].Value = '客户经理';
								}
							}else if(userInfo.fullName.indexOf("华西区/房友圈/联动拓展部") > -1){
								if(userInfo.PositionName == '拓展经理'){
									that.templateData.TemplateContent.Controls[i].Value = '拓展总监';
								}
							}
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "电话号码") {
							that.templateData.TemplateContent.Controls[i].Value = userInfo.Mobile;
							that.templateData.TemplateContent.Controls[i].Disable = true;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "直属上司姓名") {
							if (userInfo.fullName.indexOf("住宅部") > -1 ||
								userInfo.fullName.indexOf("商业地产部") > -1 ||
								userInfo.fullName.indexOf("按揭金融服务中心") > -1) {
								that.templateData.TemplateContent.Controls[i].Value = directSuperiors.EmpName;
								that.templateData.TemplateContent.Controls[i].Disable = true;
								if (that.templateData.TemplateContent.Controls[i].Value == null || that.templateData.TemplateContent.Controls[
										i].Value.length == 0) {
									that.templateData.TemplateContent.Controls[i].IsShow = false;
								}
							} else {
								that.templateData.TemplateContent.Controls[i].IsShow = false;
							}

						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "直属上司电话号码") {
							if (userInfo.fullName.indexOf("住宅部") > -1 ||
								userInfo.fullName.indexOf("商业地产部") > -1 ||
								userInfo.fullName.indexOf("按揭金融服务中心") > -1) {
								that.templateData.TemplateContent.Controls[i].Value = directSuperiors.Mobile;
								that.templateData.TemplateContent.Controls[i].Disable = true;
								if (that.templateData.TemplateContent.Controls[i].Value == null || that.templateData.TemplateContent.Controls[
										i].Value.length == 0) {
									that.templateData.TemplateContent.Controls[i].IsShow = false;
								}
							} else {
								that.templateData.TemplateContent.Controls[i].IsShow = false;
							}
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "直属上司职位") {
							if (userInfo.fullName.indexOf("住宅部") > -1 ||
								userInfo.fullName.indexOf("商业地产部") > -1) {
								that.templateData.TemplateContent.Controls[i].Value = directSuperiors.PositionName;
								that.templateData.TemplateContent.Controls[i].Disable = true;
								if (that.templateData.TemplateContent.Controls[i].Value == null || that.templateData.TemplateContent.Controls[
										i].Value.length == 0) {
									that.templateData.TemplateContent.Controls[i].IsShow = false;
								}
							} else {
								that.templateData.TemplateContent.Controls[i].IsShow = false;
							}
							if(userInfo.fullName.indexOf("营业部/工商铺商业运营中心/项目部") > -1){
								if(directSuperiors.PositionName == '项目总监'){
									that.templateData.TemplateContent.Controls[i].Value = '项目部总经理';
								}else if(directSuperiors.PositionName == '高级项目销售经理'){
									that.templateData.TemplateContent.Controls[i].Value = '高级项目总监';
								}else if(directSuperiors.PositionName == '项目销售经理'){
									that.templateData.TemplateContent.Controls[i].Value = '项目总监';
								}else if(directSuperiors.PositionName == '项目销售主管'){
									that.templateData.TemplateContent.Controls[i].Value = '销售经理助理';
								}else if(directSuperiors.PositionName == '高级置业顾问'){
									that.templateData.TemplateContent.Controls[i].Value = '客户经理';
								}
							}
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "邮箱") {
							that.templateData.TemplateContent.Controls[i].Value = userInfo.DomainAccount + "@centaline.com.cn";
							that.templateData.TemplateContent.Controls[i].Disable = true;
						} else if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "经纪人编号") {
							if (userInfo.fullName.indexOf("住宅部") > -1 ||
								userInfo.fullName.indexOf("商业地产部") > -1) {
								if (agentInfo.Body != null && agentInfo.Body.agentCardNumber != null && agentInfo.Body.agentCardNumber.length>0) {
									that.templateData.TemplateContent.Controls[i].Value = agentInfo.Body.agentCardNumber;
									that.templateData.TemplateContent.Controls[i].IsShow = true;
								}else{
									that.templateData.TemplateContent.Controls[i].Value = null;
									that.templateData.TemplateContent.Controls[i].IsShow = false;
								}
								if (that.templateData.TemplateContent.Controls[i].Value == null || that.templateData.TemplateContent.Controls[
										i].Value.length == 0) {
									that.templateData.TemplateContent.Controls[i].IsShow = false;
								}
								that.templateData.TemplateContent.Controls[i].Disable = true;
							} else {
								that.templateData.TemplateContent.Controls[i].IsShow = false;
							}

							that.templateData.TemplateContent.Controls[i].Disable = true;
						}

					}

				}
				this.listLoading = false;
			},

			// 查询分行地址
			queryAddress() {
				let that = this;
				that.$http({
					url: that.$httpUrl.QueryAddress + "?deptName=" + userInfo.DeptName,
					method: "get",
				}).then(res => {
					if (res.data.body) {
						for (let k = 0; k < res.data.body.length; k++) {
							if (res.data.body[k].deptName.indexOf("后勤") == -1) {
								that.branchAddress = res.data.body[k].address;
							}
						}
					}
				}, err => {
					console.log(err)
				})
			},
			getSelectorVal(val, name) {
				var that = this;
				if (name == "是否空名片") {
					that.templateData.TemplateContent.Controls.forEach(async (item) => {
						if (item.Property.Title[0].Text == "是否空名片") {
							item.Config.Selector.Options.forEach(async (option) => {
								if (option.Key == val && option.Value[0].Text == "是") {
									that.hideInfo();
									that.templateData.TemplateContent.Controls.forEach(async (item) => {
										if (item.Property.Title[0].Text == "分行地址") {
											if (!that.branchAddress) { //item.Value
												item.IsShow = false;
											} else {
												item.Value = that.branchAddress;
												item.IsShow = true;
												item.Disable = true;
											}
										}
									})
									that.cardIndex = 12;
									if (that.honor == 'DSA') {
										that.imgShow = false;
									} else {
										that.imgShow = true;
									}

								} else if (option.Key == val && option.Value[0].Text == "否") {
									that.templateData.TemplateContent.Controls.forEach(async (control) => {
										if (control.Property.Title[0].Text == "使用者工号") {
											this.getTextVal(control.Value, "使用者工号");
										}
										// if (control.Property.Title[0].Text == "分行地址") {
										// 	control.IsShow = false;
										// }
									})

								}
							});
						}
					})
				}
			},
			showInfo() {
				let that = this;
				if (userInfo == null) {
					return;
				}
				// that.imgShow = true;
				for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
					if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "个人荣誉" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门名称") {
						if (userInfo.fullName.indexOf("非营业部") > -1 ||
							userInfo.fullName.indexOf("二级市场") > -1 ||
							userInfo.fullName.indexOf("代理") > -1 ||
							userInfo.fullName.indexOf("住宅部") > -1 ||
							userInfo.fullName.indexOf("联动项目部") > -1 ||
							userInfo.fullName.indexOf("企业顾问中心") > -1 ||
							userInfo.fullName.indexOf("赋能中心") > -1 ||
							userInfo.fullName.indexOf("商业地产部") > -1) {
							that.templateData.TemplateContent.Controls[i].IsShow = true;
						}
					}
					if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "个人微店网址") {
						if (userInfo.fullName.indexOf("住宅部") > -1 && userInfo.fullName.indexOf("非营业") == -1) {
							that.templateData.TemplateContent.Controls[i].IsShow = true;
						}
					}
					if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "直属上司姓名" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "直属上司电话号码") {
						if (((userInfo.fullName.indexOf("按揭金融服务中心") > -1 && userInfo.fullName.indexOf("金融") > -1) ||
								userInfo.fullName.indexOf("商业地产部") > -1 ||
								userInfo.fullName.indexOf("住宅部") > -1) && userInfo.fullName.indexOf("非营业") == -1) {
							that.templateData.TemplateContent.Controls[i].IsShow = true;
						}
					}
					if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "直属上司职位" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "经纪人编号") {
						if ((userInfo.fullName.indexOf("商业地产部") > -1 ||
								userInfo.fullName.indexOf("住宅部") > -1) && userInfo.fullName.indexOf("非营业") == -1) {
							that.templateData.TemplateContent.Controls[i].IsShow = true;
						}
					}
					if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "公司电话") {
						if (userInfo.fullName.indexOf("按揭金融服务中心") > -1) {
							that.templateData.TemplateContent.Controls[i].IsShow = true;
						}
					}
					if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "投诉热线" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "投诉邮箱" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "官网地址") {
						if (userInfo.fullName.indexOf("非营业部") > -1 ||
							userInfo.fullName.indexOf("二级市场") > -1 ||
							userInfo.fullName.indexOf("代理") > -1 ||
							userInfo.fullName.indexOf("住宅部") > -1 ||
							userInfo.fullName.indexOf("商业地产部") > -1) {
							that.templateData.TemplateContent.Controls[i].IsShow = true;
						}
					}
					if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "姓名" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "职位名称" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "手机号" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "邮箱" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "公司地址" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "电话号码") {
						that.templateData.TemplateContent.Controls[i].IsShow = true;
					}

				}
			},
			hideInfo() { //隐藏名片信息
				let that = this;
				// that.imgShow = false;
				for (var i = 0; i < that.templateData.TemplateContent.Controls.length; i++) {
					if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "个人荣誉" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "姓名" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "部门名称" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "职位名称" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "手机号" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "邮箱" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "个人微店网址" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "直属上司姓名" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "直属上司职位" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "直属上司电话号码" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "经纪人编号" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "公司地址" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "分行地址" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "公司电话" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "投诉热线" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "投诉邮箱" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "邮箱" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "电话号码" ||
						that.templateData.TemplateContent.Controls[i].Property.Title[0].Text == "官网地址") {
						that.templateData.TemplateContent.Controls[i].IsShow = false;
						that.templateData.TemplateContent.Controls[i].Value = "";
						that.templateData.TemplateContent.Controls[i].Values = [];
					}
				}
			},
			submit() {
				let that = this;
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (userInfo == null || userInfo.length == 0) {
					that.$Message.error({ //error： 错误信息、success：成功、info：普通、warning：警告
						background: true,
						content: '请输入正确的工号'
					});
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
				}
				that.$http.post(that.$httpUrl.startProcess + "?temId=" + stringUtils.GetQueryString("templateId") + "&empNo=" +
					logInfo.EmpNo + "&spNo=" + stringUtils.GetQueryString("spNo"), that.templateData).
				then(res => {
					isSubmit = false;
					if (res.data.ErrCode == 0) {
						that.$message.info("提交成功");
						that.$router.push("/index");
					} else {
						that.$message.error(res.data.ErrMsg);
					}
				}, err => {
					console.log(err)
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}

	.card-examples {
		width: 100%;
		margin-top: 12px;

		.title {
			width: 100%;
			padding: 10px 15px;
			line-height: 24px;
			background-color: #FFFFFF;
			font-size: 14px;
		}

		.card-examples-arr {
			position: relative;
			width: 100%;
			overflow: hidden;
			padding: 0 15px;
			background: #fff;

			.block {
				display: inline-block;
				width: 50%;
				margin-bottom: 10px;

				img {
					width: 100%;
					height: auto;
				}
			}

			.block:nth-child(2n-1) {
				padding-right: 5px;
			}

			.block:nth-child(2n) {
				padding-left: 5px;
			}
		}
	}

	.jurisdiction-tips {
		padding: 10px 15px 0;
		color: #ff5a54;
		font-size: 15px;
	}
</style>
